document.addEventListener("scroll", () => {
	let { top, height } = document.querySelector("section").getBoundingClientRect();

	document.getElementById("scrolling-header").classList.toggle("visible", top + height < 0);
}, { passive: true });

document.querySelector("#scrolling-header .toggle").addEventListener("click", () => document.getElementById("scrolling-header").classList.toggle("open"));

document.querySelectorAll("#scrolling-header .menu a.page").forEach(link => link.innerHTML = link.innerHTML.replace(/the/gi, txt => `<em>${txt}</em>`));